import React from "react";
import { observer, useLocalStore } from "mobx-react";
import { EOCAsyncSelect } from "../input/EOCAsyncSelect";
import { Grid } from "@mui/material";
import apiCall from "../../scripts/apiCall";
import { useMsal } from "@azure/msal-react";

/**
 *
 * @param {Object} value {CustomerName,CustomerID}
 * @returns "{value,label,Name,ID}"
 */

const SAPCustomerPicker = ({
  title,
  value,
  required,
  updatefunc,
  multi = false,
  isCreatable = false,
  extrafilter = " and AccountGroup eq '0001'",
  extraSelect = "",
  isClearable = false,
}) => {
  const { instance, accounts } = useMsal();
  const getData = (input) =>
    new Promise((resolve) => {
      const select =
        extraSelect === "*" ? "*" : "CustomerID,CustomerName" + extraSelect;
      let fetchOptions = {
        method: "POST",
        body: JSON.stringify({
          proj: "Z_GW_PROSPECT_SRV",
          funct: "CustomerSet",
          parameters: `$top=30&$filter=CustomerID eq '*${input}*' or CustomerName eq '*${input}*'${extrafilter}&$orderby=CustomerName%20asc&$select=${select}&$format=json`,
        }),
      };
      var sys = window.localStorage.getItem("QUOTEsys");
      let url = `SAPOData${sys}`;
      return apiCall(
        url,
        fetchOptions,
        (json) =>
          resolve(
            json.map((result) =>
              extraSelect !== ""
                ? {
                    ...result,
                    Name: result.CustomerName,
                    Id: result.CustomerID,
                    value: result.CustomerName,
                    label:
                      result.CustomerName +
                      " (" +
                      result.CustomerID +
                      ") " +
                      result.City +
                      "/" +
                      result.Country,
                    // __metadata: undefined,
                  }
                : {
                    Name: result.CustomerName,
                    Id: result.CustomerID,
                    value: result.CustomerName,
                    label: result.CustomerName + " (" + result.CustomerID + ")",
                  }
            )
          ),
        instance,
        accounts
      );
      // return window
      //   .fetch(url, fetchOptions)
      //   .then((res) => res.json())
      //   .then((json) => {
      //     resolve(
      //       json.map((result) =>
      //         extraSelect !== ""
      //           ? {
      //               ...result,
      //               Name: result.CustomerName,
      //               Id: result.CustomerID,
      //               value: result.CustomerName,
      //               label: result.CustomerName + " (" + result.CustomerID + ")",
      //               // __metadata: undefined,
      //             }
      //           : {
      //               Name: result.CustomerName,
      //               Id: result.CustomerID,
      //               value: result.CustomerName,
      //               label: result.CustomerName + " (" + result.CustomerID + ")",
      //             }
      //       )
      //     );
      //   });
    });

  const lstore = useLocalStore(() => ({
    onChange(newVal, actionMeta) {
      console.log(newVal);
      if (newVal !== null) {
        if (multi) {
          if (isCreatable && actionMeta.action === "create-option")
            newVal.forEach((element) => {
              if (element.__isNew__) {
                element.Name = element.label;
                element.Id = "0";
              }
            });
          updatefunc(newVal);
        } else {
          if (newVal.__isNew__) {
            newVal.Name = newVal.label;
            newVal.Id = "0";
          }
          updatefunc(newVal);
        }
      } else {
        updatefunc(null);
      }
    },
  }));

  return (
    <Grid container spacing={0} direction="column">
      <Grid item xs>
        <label>
          {title}
          {required && " *"}
        </label>
      </Grid>
      <Grid item xs>
        <EOCAsyncSelect
          cy={title}
          isMulti={multi}
          loadOptions={getData}
          value={
            value !== null
              ? multi
                ? value.map((el) => ({
                    ...el,
                    value: el.Id,
                    label: el.Name,
                  }))
                : {
                    ...value,
                    label: value.Name,
                    value: value.Id,
                  }
              : null
          }
          updateF={lstore.onChange}
          clearAble={isClearable}
          isCreatable={isCreatable}
          defaultOptions
        />
      </Grid>
    </Grid>
  );
};

export default observer(SAPCustomerPicker);
